/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iade_Iptal_S8_P1Inputs */

const tr_iade_iptal_s8_p1 = /** @type {(inputs: Iade_Iptal_S8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sağlayıcı aşağıdaki hallerde Abonelik'i tek taraflı feshetme veya askıya alma hakkını saklı tutar:`)
};

const en_iade_iptal_s8_p1 = /** @type {(inputs: Iade_Iptal_S8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Provider reserves the right to terminate or suspend the Subscription unilaterally in the following cases:`)
};

const de_iade_iptal_s8_p1 = /** @type {(inputs: Iade_Iptal_S8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Anbieter behält sich das Recht vor, das Abonnement in den folgenden Fällen einseitig zu beenden oder auszusetzen:`)
};

const ru_iade_iptal_s8_p1 = /** @type {(inputs: Iade_Iptal_S8_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Поставщик оставляет за собой право в одностороннем порядке расторгнуть или приостановить Подписку в следующих случаях:`)
};

/**
* | output |
* | --- |
* | "The Provider reserves the right to terminate or suspend the Subscription unilaterally in the following cases:" |
*
* @param {Iade_Iptal_S8_P1Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const iade_iptal_s8_p1 = /** @type {((inputs?: Iade_Iptal_S8_P1Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iade_Iptal_S8_P1Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_iade_iptal_s8_p1(inputs)
	if (locale === "de") return de_iade_iptal_s8_p1(inputs)
	if (locale === "ru") return ru_iade_iptal_s8_p1(inputs)
	return tr_iade_iptal_s8_p1(inputs)
});